export const AuthConstants = {
  SET_AUTH_INFO: 'SET_AUTH_INFO',
  SET_USER_PROFILE: 'SET_USER_PROFILE',
  DELETE_AUTH_INFO: 'DELETE_AUTH_INFO',
  UPDATE_USER: 'UPDATE_USER',
} as const

export type AuthConstantType = typeof AuthConstants[keyof typeof AuthConstants]
